export const environment = {
  production: false,
  hmr: true,
  serverUrl: 'https://uatprocureapi.elitetraveltech.in',
  // serverUrl: 'https://172.17.211.194:1007',
  // serverUrl: 'http:// 192.168.20.207', //rajhans
  //  serverUrl: 'http:// 192.168.20.194:6789',
  // serverUrl: 'https://procurementapi.elitetraveltech.in',
  // serverUrl: 'https://procurementapi.elitetraveltech.in',
  //  serverUrl: 'http://192.168.20.165:8000', //ashutosh
  // serverUrl: 'https://procurementapi.elitetraveltech.in',
  // serverUrl: 'https://procurementapi.elitetraveltech.in',
  //  serverUrl: 'http://192.168.20.129:1007',
  // serverUrl: 'http://localhost:1007', //local
  // serverUrl: 'http://localhost:1007', //navneet

  aiurl: "https://aiprocure.elitetraveltech.in/qa-analysis/analyse",
  aiIntakeUrl: "https://aiprocure.elitetraveltech.in",
  // serverUrl: 'http://localhost:1007', //localhost
  // aiurl: "https://aiprocure.elitetraveltech.in/analyse",
  // aiurl: 'http://192.168.20.241:6789/analyse',

  // serverUrl: 'http://192.168.20.162:1007', //yash
  // serverUrl: 'http://localhost:8000', //vishal
  defaultLanguage: 'Label',
  supportedLanguages: ['Label', 'TMSA'],
};